import { Paperclip, FileText, Download } from "lucide-react";
import { motion } from "framer-motion";

export default function BlocDocuments({ data }) {
  return (
    <motion.section 
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="workspace-card p-6 rounded-[var(--hp-radius-lg)] border border-workspace bg-surface shadow-hp-sm space-y-6"
    >
      <div className="flex items-center gap-2.5 pb-4 border-b border-workspace">
        <FileText className="w-5 h-5 text-secondary" />
        <h2 className="text-lg font-bold text-primary">Documents & Justificatifs Réglementaires</h2>
      </div>

      {data?.documents?.length > 0 ? (
        <ul className="divide-y divide-workspace">
          {data.documents.map((doc, index) => (
            <li key={index} className="flex items-center justify-between py-3.5 hover:bg-surface-muted/30 px-2 rounded-lg transition-colors">
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-lg bg-surface border border-workspace text-secondary">
                  <Paperclip className="w-4 h-4" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-primary">{doc.nom}</p>
                  {doc.dateAjout && (
                    <p className="text-xs text-subtle">
                      Ajouté le {new Date(doc.dateAjout).toLocaleDateString("fr-FR")}
                    </p>
                  )}
                </div>
              </div>
              {doc.url && (
                <a
                  href={doc.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs font-semibold text-secondary hover:text-primary flex items-center gap-1 bg-surface border border-workspace px-3 py-1.5 rounded-[var(--hp-radius-md)] shadow-hp-sm transition-colors"
                >
                  <Download className="w-3.5 h-3.5" />
                  Télécharger
                </a>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <div className="p-8 text-center text-xs text-subtle italic flex flex-col items-center gap-2">
          <FileText className="w-8 h-8 text-subtle opacity-50" />
          <span>Aucun document enregistré pour ce dossier.</span>
        </div>
      )}
    </motion.section>
  );
}
